import Rodal from 'rodal';
import { Button } from '../../../../shared/components/Button';
import '../../../../shared/styles/Orchestrator.css';
import 'rodal/lib/rodal.css';
import { ShieldOff } from 'lucide-react';

export default function CloudAccessModal({ visible, mode, onClose }) {
  const isDark = mode === 'dark';
  const borderColor = isDark ? '2px solid var(--onyx)' : '2px solid #e4e7c5';

  return (
    <Rodal
      animation='slideUp'
      visible={visible}
      onClose={onClose}
      className={isDark ? 'df_rodal_dark' : ''}
      customStyles={{
        border: borderColor,
        backgroundColor: isDark ? 'var(--jet)' : '#f6f7eb',
        color: isDark ? 'var(--ivory)' : 'var(--jet)',
        width: 460,
        height: 220,
        overflow: 'hidden',
        display: 'flex',
        flexDirection: 'column',
      }}
    >
      <div
        className={`trialment_login_form ${isDark ? 'df_modal_form_dark' : ''}`}
        style={{ height: '100%', display: 'flex', flexDirection: 'column', gap: 14 }}
      >
        <div
          style={{
            display: 'flex',
            alignItems: 'center',
            justifyContent: 'center',
            gap: 8,
            marginBottom: 6,
          }}
        >
          <ShieldOff size={20} color='#e94f37' />
          <span style={{ fontWeight: 700, fontSize: 16 }}>Cloud Access Restricted</span>
        </div>

        <div style={{ fontSize: 13, lineHeight: 1.6, opacity: 0.9 }}>
          You are not authorized to access cloud features. You may politely ask
          Theodred:{' '}
          <a
            href='mailto:theo@paradigms.gr'
            style={{ color: isDark ? '#6fa3ef' : '#1a73e8', textDecoration: 'none' }}
          >
            theo@paradigms.gr
          </a>
        </div>

        <div style={{ marginTop: 'auto', display: 'flex', justifyContent: 'flex-end' }}>
          <Button
            label='Close'
            type={isDark ? 'onyx' : 'cinnabar'}
            onPress={onClose}
          />
        </div>
      </div>
    </Rodal>
  );
}
